module.exports = __webpack_public_path__ + "img/index-ld1.e2d8a014.png";